import React                from 'react';
import classnames           from 'classnames';
import { FontAwesomeIcon }  from '@fortawesome/react-fontawesome';

import BomImportTable       from './BomImportTable';
import ErrorMessage         from './ErrorMessage';
import BomParameters        from './BomParameters';
import ErrorLabel           from 'pu-react/components/base/ErrorLabel';

const Actions = (props) => {
  return(
    <div>
      <button type="button" 
        className="btn btn-outline-gray btn-thin" 
        onClick={props.onClose} >
        CANCEL
      </button>
      &nbsp;
      <button type="button" 
        className="btn btn-orange" 
        onClick={props.onQuote} >
        CONTINUE
        &nbsp;
        <i className="fas fa-caret-right"></i>
      </button>
    </div>
  )
}

const BomToolParse = (props) => {
  return(
    <div className="bom-tool-parse">
      <BomParameters 
        parameters={props.bomParameters}
        onChange={props.onChangeParameter} 
        errors={props.errors}/>
      <div className="caption">
        CLICK DROPDOWN TO IDENTIFY PRIORITY FIELDS (Ref. Designator, MGF Part# or Vendor Part)  
      </div>
      <ErrorLabel error={props.errors.bom_parameters} />
      <BomImportTable 
        workbook={props.workbook} 
        parameters={props.bomParameters}
        onChange={props.onChangeParameter} />
      <div className="modal-footer">
        <Actions 
          onClose={props.onClose} 
          onQuote={props.onQuote} />
      </div>
    </div>
  )
}

export default BomToolParse;
